<template>
	<div>
		<div class="item padding-tb-sm padding-lr-sm margin-bottom-sm flex flex-direction justify-between" :style="[{ width: width+'px'}]">
			<div class="flex justify-between align-start">
			</div>
			<div class="flex align-center justify-between">
				<div class="flex align-center">
					<img class="block-63" :src="data.user&&data.user.avatar" mode=""></img>
					<div class="flex flex-direction flex-sub justify-between margin-left-xs">
						<div class="text-333 text-sm text-cut text-left" style="width: 150px;">{{data.user&&data.user.nick_name}}</div>
						<div class="flex align-center" v-if="data.user">
							<img v-if="data.user.is_real == 2" class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/authentication.png" mode=""></img>
							
							<img v-if="data.user.is_real_company == 2" class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/enterprise.png" mode=""></img>
							<img v-else class="block-15 margin-right-xs" src="https://manage.ciiply.com/web/static/home/random.png" mode=""></img>
							<div class="text-999 text-sm">{{data.user.is_real_company == 2?'企业已认证':data.user.is_real == 2?'个人已认证':'未认证'}}</div>
						</div>
					</div>
				</div>
				<div class="call-btn">联系TA</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  props: {
	    width: {
	      type: [String,Number],
	      default:387
	    },
	    height:{
	    	type: [String,Number],
	    	default:168
	    },
		size:{//标题字体
			type: [String,Number],
			default:18
		},
		data:{
			type: Object,
			default:{}
		}
	  },
	  mounted(){
	    
	  },
	  methods: {
	    godetail(){
			this.$router.push({
				name:'workerDetail',
				query: {
					id:this.data.id
				}
			})
		}
	  }
	};
</script>

<style scoped lang="less">
	.item{
		// width: 387px;
		// height: 168px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		position: relative;
		.block-63{
			width: 36px;
			height: 36px;
			border-radius: 50%;
		}
		.block-15{
			width: 15px;
			height: 15px;
		}
		.add{
			width: 16px;
			height: 19px;
		}
		.margin-left-8{
			margin-left: 8px;
		}
		.sticky{
			position: absolute;
			top: 0;
			right: 0;
			width: 45px;
			height: 24px;
			font-size: 13px;
			line-height: 24px;
			background: rgba(11, 131, 124, 0.1);
			border-radius: 0px 20px 0px 0px;
			color: #0B837C;
		}
		.tip-item{
			font-size: 13px;
			padding: 5px 10px;
			border-radius: 12px;
			background: #F1F1F1;
			margin-right: 9px;
		}
		.call-btn{
			width: 115px;
			height: 40px;
			line-height: 40px;
			background: #0B837C;
			color: #fff;
			border-radius: 25px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/seen/station-list.vue